<ct-lib-modal
  [medium]="true"
  [closeable]="false"
  [hideHeader]="true"
  [hideFooter]="true"
  #onboardingModal
>
  <div class="onboarding">
    @if (path() === onboardingPath.KNOWN) {
      <h4>{{ 'jobboard.platform.onboarding.known.title' | transloco }}</h4>
      <p>
        {{
          'jobboard.platform.onboarding.known.lead'
            | transloco: { count: importableApplications().length }
        }}
      </p>
      <ct-lib-radio-card-group
        class="import-list"
        [multiselect]="true"
        [value]="selectedApplicationIds()"
        (valueChange)="onImportSelectionChange($event)"
      >
        @for (application of importableApplications(); track application.id) {
          <ct-lib-radio-card
            [value]="application.id"
            [label]="application.jobTitle"
            [sublabel]="application.companyName"
            [description]="
              (application.source === importSource.CATCH_APPLY
                ? 'jobboard.platform.onboarding.known.source-apply'
                : 'jobboard.platform.onboarding.known.source-follow-up'
              ) | transloco
            "
          />
        }
      </ct-lib-radio-card-group>
      <div class="onboarding-actions">
        <app-button variant="white-grey" (click)="skipKnownOnboarding()">
          {{ 'jobboard.platform.onboarding.known.skip' | transloco }}
        </app-button>
        <app-button variant="primary" (click)="completeKnownOnboarding()">
          {{ 'jobboard.platform.onboarding.known.submit' | transloco }}
        </app-button>
      </div>
    } @else if (path() === onboardingPath.UNKNOWN) {
      @if (unknownStep() === 1) {
        <h4>
          {{
            (hasExistingProfile()
              ? 'jobboard.platform.onboarding.unknown.existing-title'
              : 'jobboard.platform.onboarding.unknown.title'
            ) | transloco
          }}
        </h4>
        <p>
          {{
            (hasExistingProfile()
              ? 'jobboard.platform.onboarding.unknown.existing-lead'
              : 'jobboard.platform.onboarding.unknown.lead'
            ) | transloco
          }}
        </p>
        @if (existingDocuments().length > 0) {
          <div class="existing-docs">
            <p>{{ 'jobboard.platform.onboarding.unknown.existing-docs' | transloco }}</p>
            <ul>
              @for (document of existingDocuments(); track document.id) {
                <li>{{ document.name }}</li>
              }
            </ul>
          </div>
        }
        <ct-lib-file-input
          [control]="cvControl"
          [multiple]="false"
          accept="application/pdf,.pdf,.doc,.docx"
          [label]="'jobboard.platform.onboarding.unknown.cv-label' | transloco"
        />
        <div class="onboarding-actions">
          <app-button variant="white-grey" (click)="skipCvUpload()">
            {{ 'jobboard.platform.onboarding.unknown.skip' | transloco }}
          </app-button>
          <app-button
            variant="primary"
            [loading]="extracting()"
            [iconStart]="hasCvFile() ? icons.fileArrowUp : undefined"
            (click)="continueUnknownStep()"
          >
            {{
              (hasCvFile()
                ? 'jobboard.platform.onboarding.unknown.continue'
                : hasExistingProfile()
                  ? 'jobboard.platform.onboarding.unknown.continue-existing'
                  : 'jobboard.platform.onboarding.unknown.continue-empty'
              ) | transloco
            }}
          </app-button>
        </div>
      } @else {
        <h4>{{ 'jobboard.platform.onboarding.unknown.confirm-title' | transloco }}</h4>
        <p>{{ 'jobboard.platform.onboarding.unknown.confirm-lead' | transloco }}</p>
        @if (existingDocuments().length > 0) {
          <div class="existing-docs">
            <p>{{ 'jobboard.platform.onboarding.unknown.existing-docs' | transloco }}</p>
            <ul>
              @for (document of existingDocuments(); track document.id) {
                <li>{{ document.name }}</li>
              }
            </ul>
          </div>
        }
        <form class="profile-form" [formGroup]="profileForm" (ngSubmit)="completeUnknownOnboarding()">
          <div class="form-group" [class.invalid]="firstName.invalid && profileSubmitAttempt()">
            <input
              class="form-control"
              type="text"
              [formControl]="firstName"
              [placeholder]="'jobboard.platform.onboarding.unknown.first-name' | transloco"
              autocomplete="given-name"
            />
            <div class="validation">
              @if (firstName.errors?.['required']) {
                <p>{{ 'ct-library.validation.required' | transloco }}</p>
              }
            </div>
          </div>
          <div class="form-group" [class.invalid]="lastName.invalid && profileSubmitAttempt()">
            <input
              class="form-control"
              type="text"
              [formControl]="lastName"
              [placeholder]="'jobboard.platform.onboarding.unknown.last-name' | transloco"
              autocomplete="family-name"
            />
            <div class="validation">
              @if (lastName.errors?.['required']) {
                <p>{{ 'ct-library.validation.required' | transloco }}</p>
              }
            </div>
          </div>
          <div class="form-group">
            <input class="form-control" type="email" [value]="sessionEmail()" disabled />
          </div>
          <div class="form-group">
            <input
              class="form-control"
              type="tel"
              [formControl]="profileForm.controls['phone']"
              [placeholder]="'jobboard.platform.onboarding.unknown.phone' | transloco"
              autocomplete="tel"
            />
          </div>
          @if (skills().length > 0) {
            <div class="skills">
              <p>{{ 'jobboard.platform.onboarding.unknown.skills' | transloco }}</p>
              <div class="skill-list">
                @for (skill of skills(); track skill) {
                  <ct-lib-tag [deletable]="true" (onDelete)="removeSkill(skill)">
                    {{ skill }}
                  </ct-lib-tag>
                }
              </div>
            </div>
          }
          <div class="onboarding-actions">
            <app-button variant="white-grey" htmlType="button" (click)="backToUnknownStart()">
              {{ 'jobboard.platform.onboarding.unknown.back' | transloco }}
            </app-button>
            <app-button variant="primary" htmlType="submit" [iconStart]="icons.user">
              {{ 'jobboard.platform.onboarding.unknown.submit' | transloco }}
            </app-button>
          </div>
        </form>
      }
    }
  </div>
</ct-lib-modal>
